import { IconInterface } from '../interfaces/icon.interface';

const AddressesClock = (props: IconInterface) => {
	const { color = '#454545', width = 15, height = 15 } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="7.5" cy="7.5" r="7" stroke={color} />
			<path
				d="M7.5 4.70312V7.50312L8.9 8.90312"
				stroke={color}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default AddressesClock;
